import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { cx } from "lib/cx";
import { useState } from "react";
import { ThemeColorForm } from "./ThemeColorForm";
import { FontSizeForm } from "./FontSizeForm";
import { FontFamilyForm } from "./FontFamilyForm";
import { DocumentSizeForm } from "./DocumentSizeForm";

interface MobileThemeFormProps {
  setOpenMobileThemeForm: (visible: boolean) => void;
}

export const MobileThemeForm = ({
  setOpenMobileThemeForm,
}: MobileThemeFormProps) => {
  const [themeSection, setThemeSection] = useState("themeColor");
  const [isExitingPreview, setIsExitingPreview] = useState(false); // State to handle exit animation
  const [isEnteringPreview, setIsEnteringPreview] = useState(true); // State to handle entry animation

  const handleClose = () => {
    setIsExitingPreview(true); // Trigger the exit animation
    setTimeout(() => {
      setOpenMobileThemeForm(false); // Remove the preview after animation
      setIsExitingPreview(false); // Reset exit state
    }, 500); // Adjust timing based on animation duration
  };

  return (
    <section
      className={cx(
        "fixed z-[110] h-[40%] w-full bg-white shadow-lg lg:hidden",
        "bottom-0",
        isExitingPreview && "fade-out-bottom", // Fade out to bottom when exiting
        isEnteringPreview && "fade-in-bottom" // Fade in bottom when entering
      )}
      id="mobile-theme-form"
    >
      <div className="relative flex h-full w-full flex-col pt-3">
        <div className="absolute -top-3 left-1/2 h-6 w-6 -translate-x-1/2 rounded-full bg-[#3c3c3c] p-1 text-white">
          <ChevronDownIcon onClick={handleClose} />
        </div>

        <ul className="flex w-full justify-around px-1 py-2 font-montserrat text-[9.5px] md:text-xs">
          <li
            className={`${
              themeSection === "themeColor" ? "blue-gradient text-white" : ""
            } rounded-xl px-2 py-1`}
            onClick={() => setThemeSection("themeColor")}
          >
            Theme Color
          </li>
          <li
            className={`${
              themeSection === "fontSize" ? "blue-gradient text-white" : ""
            } rounded-xl px-2 py-1`}
            onClick={() => setThemeSection("fontSize")}
          >
            Font Size
          </li>
          <li
            className={`${
              themeSection === "fontFamily" ? "blue-gradient text-white" : ""
            } rounded-xl px-2 py-1`}
            onClick={() => setThemeSection("fontFamily")}
          >
            Font Family
          </li>
          <li
            className={`${
              themeSection === "documentSize" ? "blue-gradient text-white" : ""
            } rounded-xl px-2 py-1`}
            onClick={() => setThemeSection("documentSize")}
          >
            Document Size
          </li>
        </ul>
        <div className="overflow-y-auto scrollbar-thin">
          {themeSection === "themeColor" && <ThemeColorForm />}
          {themeSection === "fontSize" && <FontSizeForm />}
          {themeSection === "fontFamily" && <FontFamilyForm />}
          {themeSection === "documentSize" && <DocumentSizeForm />}
        </div>
      </div>
    </section>
  );
};
